import Swiper from 'swiper/bundle';

export default class Carousels {
	constructor(){
		this.carousel = {
            caseStudies: document.querySelectorAll('.carousel[data-carousel="carouselCaseStudies"]'),
            references: document.querySelectorAll('.carousel[data-carousel="carouselReferences"]'),
            referencesDemo: document.querySelectorAll('.carousel[data-carousel="carouselReferencesDemo"]'),
            team: document.querySelectorAll('.carousel[data-carousel="carouselTeam"]'),
            grid_items: document.querySelectorAll('.carousel[data-carousel="grid-items"]'),
		};
	}

	init() {
        if(this.carousel.caseStudies) { this.carouselCaseStudies(); }
        if(this.carousel.references) { this.carouselReferences(); }
        if(this.carousel.referencesDemo) { this.carouselReferencesDemo(); }
        if(this.carousel.team) { this.carouselTeam(); }
        if(this.carousel.grid_items) { this.gridItems(); }
	}

    carouselCaseStudies = () => {
        this.carousel.caseStudies.forEach(carousel => {
            var items = carousel.querySelectorAll('.item-case-studies'),
                scrollbar = carousel.querySelector('.scrollbar');

            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.classList.add('pb-3');
            }

            carousel.parentNode.classList.add('overflow-hidden');
            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                spaceBetween: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 3,
                    }, 
                }
            });
        })
    } 

    carouselReferences = () => {
        this.carousel.references.forEach(carousel => {
            var items = carousel.querySelectorAll('.item-references'),
                scrollbar = carousel.querySelector('.scrollbar');

            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.classList.add('pb-3');
            }

            carousel.parentNode.classList.add('overflow-hidden');
            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                grid: {
                    rows: 2
                  },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 5,
                    }, 
                },
            });
        })
    }

    carouselReferencesDemo = () => {
        this.carousel.referencesDemo.forEach(carousel => {
            var items = carousel.querySelectorAll('.item-references'),
                scrollbar = carousel.querySelector('.scrollbar');

            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.classList.add('pb-3');
            }

            carousel.parentNode.classList.add('overflow-hidden');
            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                grid: {
                    rows: 2
                  },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 3,
                    }, 
                    // when window width is >= 1600px
                    1600: {
                        slidesPerView: 5,
                    }
                },
            });
        })
    }

    carouselTeam = () => {
        this.carousel.team.forEach(carousel => {
            var items = carousel.querySelectorAll('.item-team'),
                scrollbar = carousel.querySelector('.scrollbar');

            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.classList.add('pb-3');
            }

            carousel.parentNode.classList.add('overflow-hidden');
            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                grid: {
                    rows: 2
                  },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 3,
                    }, 
                },
            });
        })
    }

    gridItems = () => {
        this.carousel.grid_items.forEach(carousel => {
            var items = carousel.querySelectorAll('.item');
            
            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }
            
            
            var wrapper = '<div class="swiper-wrapper">' + carousel.innerHTML + '<div class="scrollbar"></div></div>';
            
            carousel.innerHTML = wrapper;
            carousel.parentNode.classList.add('overflow-hidden');
            
            var scrollbar = carousel.querySelector('.scrollbar');

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.append(scrollbar);
                carousel.querySelector('.scrollbar').remove();
                carousel.classList.add('pb-3');
            }

            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                grid: {
                    fill: 'row',
                    rows: 1,
                },
                spaceBetween: 4,
                scrollbar: {
                    el: carousel.querySelector('.scrollbar'),
                    draggable: true,
                    // hide: true,
                },
                mousewheel: {
                    // invert: true,
                    forceToAxis: true,
                },
                breakpoints: {
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: carousel.getAttribute('data-items'),
                        grid: {
                            fill: 'row',
                            rows: 2,
                        },
                    }
                  }
            });
        })
    } 
}
